import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useParams } from "react-router-dom";

import { getOrder } from "./order-details-section.service";
import {
  downloadOrderExcel,
  downloadOrderXML,
} from "../admin/orders/orders-section.service";

export default function OrderDetailsSection() {
  const [orderDetails, setOrder] = useState<any>();
  const [loader, setLoader] = useState(true);
  const [excelLoader, setExcelLoader] = useState(false);
  const [xmlLoader, setXmlLoader] = useState(false);
  const params = useParams();

  useEffect(() => {
    if (!params.id) {
      return;
    }
    getOrder(params.id).then((res) => {
      setOrder(res.data);
      setLoader(false);
    });
  }, [params.id]);

  if (loader) {
    return <div>Loading...</div>;
  }

  if (orderDetails.length === 0) {
    return (
      <div className="text-center">
        <h1>No orders found</h1>
      </div>
    );
  }

  const handleDownloadExcel = (orderId: string) => {
    setExcelLoader(true);
    downloadOrderExcel(orderId).then((response: any) => {
      const data = new Uint8Array(response.data.data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const date = moment().format("DD-MM-YYYY HH:mm");
      link.setAttribute("download", `order_${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
      setExcelLoader(false);
    });
  };

  const handleDownloadXML = (orderId: string) => {
    setXmlLoader(true);
    downloadOrderXML(orderId).then((response: any) => {
      const data = new Uint8Array(response.data.data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const date = moment().format("DD-MM-YYYY HH:mm");
      link.setAttribute("download", `order_${date}.xml`);
      document.body.appendChild(link);
      link.click();
      setXmlLoader(false);
    });
  };

  return (
    <section className="ec-page-content section-space-p">
      <div className="container">
        <div className="row">
          <div className="ec-cart-leftside col-lg-12 col-md-12">
            <div className="ec-cart-content">
              <div className="ec-cart-inner">
                <div className="row">
                  <form action="#">
                    <div className="table-content cart-table-content">
                      <table>
                        <thead>
                          <tr>
                            <th className="product_thumb">Image</th>
                            <th className="product_thumb">Product Name</th>
                            <th className="product_thumb">Product Code</th>
                            <th className="product_thumb">
                              Size In {orderDetails.size} (length x width x
                              height)
                            </th>
                            <th className="product_thumb">Quantity</th>
                          </tr>
                        </thead>
                        <tbody>
                          {orderDetails.wishlist.map((order: any) => (
                            <tr key={order.id}>
                              <td className="product_thumb">
                                <img
                                  height={70}
                                  width={70}
                                  src={`https://d1gdand68muq63.cloudfront.net/${
                                    order.product?.isSample
                                      ? "sample-products"
                                      : "products"
                                  }/sm/${order.product?.image?.key}`}
                                  alt={order.product?.name}
                                />
                              </td>
                              <td className="product_name">
                                <Link to={`/product/${order.product.id}`}>
                                  {order.product.name}
                                </Link>
                              </td>
                              <td className="product_code">
                                {order.product.code}
                              </td>
                              <td className="product_size">
                                {order.product[orderDetails.size].length} x{" "}
                                {order.product[orderDetails.size].width} x{" "}
                                {order.product[orderDetails.size].height}
                              </td>
                              <td className="product_quantity">
                                {order.quantity}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </form>
                  <div className="cart_submit mt-4">
                    <button
                      className="btn btn-primary mr-2"
                      type="button"
                      onClick={() => {
                        if (params.id) handleDownloadExcel(params.id);
                      }}
                      disabled={excelLoader}
                    >
                      {excelLoader ? "Downloading..." : "Download Orders"}
                    </button>
                    <button
                      className="btn btn-primary "
                      type="button"
                      onClick={() => {
                        if (params.id) handleDownloadXML(params.id);
                      }}
                      disabled={xmlLoader}
                    >
                      {xmlLoader ? "Downloading..." : "Download XML"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
